import _definePage_default_0 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/accept-invite/[token].vue?definePage&vue'
import _definePage_default_4 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/account.vue?definePage&vue'
import _definePage_default_5 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/clients/index.vue?definePage&vue'
import _definePage_default_6 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/clients/[clientId].vue?definePage&vue'
import _definePage_default_7 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dashboard.vue?definePage&vue'
import _definePage_default_8 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/index.vue?definePage&vue'
import _definePage_default_9 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/index.vue?definePage&vue'
import _definePage_default_10 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/calendar.vue?definePage&vue'
import _definePage_default_11 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/index.vue?definePage&vue'
import _definePage_default_12 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/[offeringId].vue?definePage&vue'
import _definePage_default_13 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/new.vue?definePage&vue'
import _definePage_default_14 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/rentals.vue?definePage&vue'
import _definePage_default_15 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/seasons/index.vue?definePage&vue'
import _definePage_default_16 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/seasons/[seasonId].vue?definePage&vue'
import _definePage_default_17 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/services.vue?definePage&vue'
import _definePage_default_18 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/profile/edit.vue?definePage&vue'
import _definePage_default_19 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/profile.vue?definePage&vue'
import _definePage_default_20 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/new.vue?definePage&vue'
import _definePage_default_21 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/forgot-password.vue?definePage&vue'
import _definePage_default_22 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/intake/[token].vue?definePage&vue'
import _definePage_default_23 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/login.vue?definePage&vue'
import _definePage_default_24 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/register/index.vue?definePage&vue'
import _definePage_default_25 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/register/email.vue?definePage&vue'
import _definePage_default_26 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/register/setup.vue?definePage&vue'
import _definePage_default_27 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/register/verify.vue?definePage&vue'
import _definePage_default_28 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/reports/sales.vue?definePage&vue'
import _definePage_default_29 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/reset-password.vue?definePage&vue'
import _definePage_default_30 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/client-report.vue?definePage&vue'
import _definePage_default_31 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/quotes/index.vue?definePage&vue'
import _definePage_default_32 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/quotes/[quoteId]/index.vue?definePage&vue'
import _definePage_default_33 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/quotes/[quoteId]/preview.vue?definePage&vue'
import _definePage_default_34 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/receipts/index.vue?definePage&vue'
import _definePage_default_35 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/receipts/[receiptId]/index.vue?definePage&vue'
import _definePage_default_36 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/receipts/[receiptId]/preview.vue?definePage&vue'
import _definePage_default_37 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/reports.vue?definePage&vue'
import _definePage_default_38 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/index.vue?definePage&vue'
import _definePage_default_39 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/closed-days.vue?definePage&vue'
import _definePage_default_40 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/company.vue?definePage&vue'
import _definePage_default_41 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/danger.vue?definePage&vue'
import _definePage_default_42 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/medical-questionnaire.vue?definePage&vue'
import _definePage_default_43 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/preferences.vue?definePage&vue'
import _definePage_default_44 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/profile.vue?definePage&vue'
import _definePage_default_45 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/security.vue?definePage&vue'
import _definePage_default_46 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/subscription.vue?definePage&vue'
import _definePage_default_47 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/team.vue?definePage&vue'
import _definePage_default_48 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/theme.vue?definePage&vue'
import _definePage_default_49 from '/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/team.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/accept-invite',
    /* internal name: 'accept-invite' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':token',
        name: 'accept-invite-token',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/accept-invite/[token].vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/account',
    name: 'account',
    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/account.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  {
    path: '/clients',
    /* internal name: 'clients' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'clients',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/clients/index.vue'),
        /* no children */
      },
  _definePage_default_5
  ),
  _mergeRouteRecord(
      {
        path: ':clientId',
        name: 'clients-client-id',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/clients/[clientId].vue'),
        /* no children */
      },
  _definePage_default_6
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dashboard.vue'),
    /* no children */
  },
  _definePage_default_7
  ),
  {
    path: '/dive-centers',
    /* internal name: 'dive-centers' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'dive-centers',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/index.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
      {
        path: ':id',
        /* internal name: 'dive-centers-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'dive-centers-id',
            component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/index.vue'),
            /* no children */
          },
  _definePage_default_9
  ),
  _mergeRouteRecord(
          {
            path: 'calendar',
            name: 'dive-centers-id-calendar',
            component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/calendar.vue'),
            /* no children */
          },
  _definePage_default_10
  ),
          {
            path: 'offerings',
            /* internal name: 'dive-centers-id-offerings' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'dive-centers-id-offerings',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/index.vue'),
                /* no children */
              },
  _definePage_default_11
  ),
  _mergeRouteRecord(
              {
                path: ':offeringId',
                name: 'dive-centers-id-offerings-offering-id',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/[offeringId].vue'),
                /* no children */
              },
  _definePage_default_12
  ),
  _mergeRouteRecord(
              {
                path: 'new',
                name: 'dive-centers-id-offerings-new',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/new.vue'),
                /* no children */
              },
  _definePage_default_13
  ),
  _mergeRouteRecord(
              {
                path: 'rentals',
                name: 'dive-centers-id-offerings-rentals',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/rentals.vue'),
                /* no children */
              },
  _definePage_default_14
  ),
              {
                path: 'seasons',
                /* internal name: 'dive-centers-id-offerings-seasons' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'dive-centers-id-offerings-seasons',
                    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/seasons/index.vue'),
                    /* no children */
                  },
  _definePage_default_15
  ),
  _mergeRouteRecord(
                  {
                    path: ':seasonId',
                    name: 'dive-centers-id-offerings-seasons-season-id',
                    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/seasons/[seasonId].vue'),
                    /* no children */
                  },
  _definePage_default_16
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'services',
                name: 'dive-centers-id-offerings-services',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/offerings/services.vue'),
                /* no children */
              },
  _definePage_default_17
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'profile',
            name: 'dive-centers-id-profile',
            component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/profile.vue'),
            children: [
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'dive-centers-id-profile-edit',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/[id]/profile/edit.vue'),
                /* no children */
              },
  _definePage_default_18
  )
            ],
          },
  _definePage_default_19
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'new',
        name: 'dive-centers-new',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/dive-centers/new.vue'),
        /* no children */
      },
  _definePage_default_20
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_21
  ),
  {
    path: '/intake',
    /* internal name: 'intake' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':token',
        name: 'intake-token',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/intake/[token].vue'),
        /* no children */
      },
  _definePage_default_22
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_23
  ),
  {
    path: '/register',
    /* internal name: 'register' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'register',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/register/index.vue'),
        /* no children */
      },
  _definePage_default_24
  ),
  _mergeRouteRecord(
      {
        path: 'email',
        name: 'register-email',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/register/email.vue'),
        /* no children */
      },
  _definePage_default_25
  ),
  _mergeRouteRecord(
      {
        path: 'setup',
        name: 'register-setup',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/register/setup.vue'),
        /* no children */
      },
  _definePage_default_26
  ),
  _mergeRouteRecord(
      {
        path: 'verify',
        name: 'register-verify',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/register/verify.vue'),
        /* no children */
      },
  _definePage_default_27
  )
    ],
  },
  {
    path: '/reports',
    /* internal name: 'reports' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'sales',
        name: 'reports-sales',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/reports/sales.vue'),
        /* no children */
      },
  _definePage_default_28
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/reset-password.vue'),
    /* no children */
  },
  _definePage_default_29
  ),
  {
    path: '/sales',
    /* internal name: 'sales' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'client-report',
        name: 'sales-client-report',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/client-report.vue'),
        /* no children */
      },
  _definePage_default_30
  ),
      {
        path: 'quotes',
        /* internal name: 'sales-quotes' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'sales-quotes',
            component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/quotes/index.vue'),
            /* no children */
          },
  _definePage_default_31
  ),
          {
            path: ':quoteId',
            /* internal name: 'sales-quotes-quote-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'sales-quotes-quote-id',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/quotes/[quoteId]/index.vue'),
                /* no children */
              },
  _definePage_default_32
  ),
  _mergeRouteRecord(
              {
                path: 'preview',
                name: 'sales-quotes-quote-id-preview',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/quotes/[quoteId]/preview.vue'),
                /* no children */
              },
  _definePage_default_33
  )
            ],
          }
        ],
      },
      {
        path: 'receipts',
        /* internal name: 'sales-receipts' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'sales-receipts',
            component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/receipts/index.vue'),
            /* no children */
          },
  _definePage_default_34
  ),
          {
            path: ':receiptId',
            /* internal name: 'sales-receipts-receipt-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'sales-receipts-receipt-id',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/receipts/[receiptId]/index.vue'),
                /* no children */
              },
  _definePage_default_35
  ),
  _mergeRouteRecord(
              {
                path: 'preview',
                name: 'sales-receipts-receipt-id-preview',
                component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/receipts/[receiptId]/preview.vue'),
                /* no children */
              },
  _definePage_default_36
  )
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'reports',
        name: 'sales-reports',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/sales/reports.vue'),
        /* no children */
      },
  _definePage_default_37
  )
    ],
  },
  {
    path: '/settings',
    /* internal name: 'settings' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'settings',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/index.vue'),
        /* no children */
      },
  _definePage_default_38
  ),
  _mergeRouteRecord(
      {
        path: 'closed-days',
        name: 'settings-closed-days',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/closed-days.vue'),
        /* no children */
      },
  _definePage_default_39
  ),
  _mergeRouteRecord(
      {
        path: 'company',
        name: 'settings-company',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/company.vue'),
        /* no children */
      },
  _definePage_default_40
  ),
  _mergeRouteRecord(
      {
        path: 'danger',
        name: 'settings-danger',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/danger.vue'),
        /* no children */
      },
  _definePage_default_41
  ),
  _mergeRouteRecord(
      {
        path: 'medical-questionnaire',
        name: 'settings-medical-questionnaire',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/medical-questionnaire.vue'),
        /* no children */
      },
  _definePage_default_42
  ),
  _mergeRouteRecord(
      {
        path: 'preferences',
        name: 'settings-preferences',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/preferences.vue'),
        /* no children */
      },
  _definePage_default_43
  ),
  _mergeRouteRecord(
      {
        path: 'profile',
        name: 'settings-profile',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/profile.vue'),
        /* no children */
      },
  _definePage_default_44
  ),
  _mergeRouteRecord(
      {
        path: 'security',
        name: 'settings-security',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/security.vue'),
        /* no children */
      },
  _definePage_default_45
  ),
  _mergeRouteRecord(
      {
        path: 'subscription',
        name: 'settings-subscription',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/subscription.vue'),
        /* no children */
      },
  _definePage_default_46
  ),
  _mergeRouteRecord(
      {
        path: 'team',
        name: 'settings-team',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/team.vue'),
        /* no children */
      },
  _definePage_default_47
  ),
  _mergeRouteRecord(
      {
        path: 'theme',
        name: 'settings-theme',
        component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/settings/theme.vue'),
        /* no children */
      },
  _definePage_default_48
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/team',
    name: 'team',
    component: () => import('/var/www/vhosts/bluetrails.eu/providers.bluetrails.eu/src/pages/team.vue'),
    /* no children */
  },
  _definePage_default_49
  )
]
